The type of the question response.

Currently, three codes are defined:

- `FreeText` for a free text response.
- `MultiSelect` for choosing one or more responses from `responseChoice`.
- `SingleSelect` for choosing a single response from `responseChoice`.
